/** localStorage key for CustomerSession Bearer (memory + Pinia also hold it). */
export const TOKEN_STORAGE_KEY = '_skuby-web-token'

/** @deprecated Use TOKEN_STORAGE_KEY — same string; kept for older imports. */
export const TOKEN_COOKIE_KEY = TOKEN_STORAGE_KEY
